<template>
  <div class="new-subscription-page">
    <PageHeader></PageHeader>
    <div class="new-subscription-form">
      <el-form ref="addsubscriptionrefs" :rules="addsubscriptionrules" :model="addform" label-width="100px" size="small">
        <el-col :span="12">
          <el-form-item label="订阅名称" prop="name">
            <el-input style="width:200px;" v-model="addform.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="品牌名称" prop="brandid">
            <el-select style="width:200px;" v-model="addform.brandid" filterable placeholder="请选择品牌">
              <el-option v-for="item in brandids" :key="item.brandId" :label="item.name" :value="item.brandId"></el-option>
            </el-select>
            <FormButton ButtonTextName="新增品牌" :onClick="addBrandDialog"></FormButton>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户账号" prop="mainid">
            <el-select style="width:200px;" v-model="addform.userid" filterable placeholder="请选择用户" 
              @change="getUserMainid(addform.userid)">
              <el-option v-for="item in brandusers" :key="item.userId" :label="item.email" :value="item.userId" 
              :disabled="item.userId == addform.duserid"></el-option>
            </el-select>
            <FormButton ButtonTextName="新增用户" :onClick="addUserDialog"></FormButton>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="代理账号" prop="agency">
            <el-select style="width:200px;" v-model="addform.duserid" filterable placeholder="请选择代理"
              @change="getAgencyMainid(addform.duserid)">
              <el-option v-for="item in agencyusers" :key="item.userId" :label="item.email" :value="item.userId"></el-option>
            </el-select>
            <FormButton ButtonTextName="新增代理" :onClick="addAgencyDialog"></FormButton>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="主负责人" prop="CSM">
            <el-select style="width:200px;" v-model="addform.CSM" filterable placeholder="请选择主负责人" 
              @change="getCSMMainid(addform.CSM)">
              <el-option v-for="item in simplyusers" :key="item.userId" :label="item.email" :value="item.userId" 
              :disabled="item.userId == addform.duserid"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="副负责人" prop="DepCSM">
            <el-select style="width:200px;" v-model="addform.DepCSM" filterable placeholder="请选择副负责人"
              @change="getDepCSMMainid(addform.DepCSM)">
              <el-option v-for="item in simplyusers" :key="item.userId" :label="item.email" :value="item.userId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="套餐等级" prop="packageid">
            <el-select style="width:200px;" v-model="addform.packageid" filterable placeholder="请选择套餐等级" @change="selectPackage(addform.packageid)">
              <el-option
                v-for="item in packageids"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="监测渠道" prop="channel">
            <el-select style="width:200px;" v-model="addform.channel" filterable placeholder="请选择渠道" multiple collapse-tags @change="getChannelName(addform.channel)">
              <el-option
                v-for="item in channels"
                :key="item.ChannelId"
                :label="item.ChannelName"
                :value="item.ChannelId">
              </el-option>
            </el-select>
            <el-checkbox v-if="showsaletype" class="customtimes" v-model="addform.saletype">
              升级<FormTooltip tipContent="仅针对天猫/淘宝平台的“成功交易”数据"></FormTooltip>
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="监测频次">
            <el-select style="width: 200px;" v-model="addform.monitortype" placeholder="请选择监测频次" @change="onChangeMonitortype">
              <el-option
                v-for="item in monitortype"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
            <el-checkbox v-if="showcustomtimes" class="customtimes" v-model="addform.isDefault" @change="onChangeMonitortime">
              自定义时间<FormTooltip tipContent="选中自定义每个监测时间点，不选中则使用默认时间点"></FormTooltip>
            </el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="监测时间">
            <el-checkbox-group v-if="addform.monitortype != 4" v-model="addform.monitortime" :min="monitortime_min" :max="monitortime_max" class="add-sub-checkbox-group">
              <el-checkbox v-for="t in monitortime" :label="t" :key="t" :disabled="addform.monitortype == ''">{{ t }}</el-checkbox>
            </el-checkbox-group>
            <span v-if="addform.monitortype == 4">每周一更新</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开始时间" prop="init">
            <el-date-picker v-model="addform.init" type="date" placeholder="选择日期" @change="getExpireDate()">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="到期时间" prop="expire">
            <el-date-picker v-model="addform.expire" type="date" placeholder="到期时间" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="定制报告" prop="url">
            <el-input v-model="addform.url"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="投诉点数" prop="tscount">
            <el-input style="width:80px;" v-model="addform.tscountadd" :disabled="checkexpire"></el-input>
            <!-- <span class="totalpointscount"><i v-if="!checkexpire">剩余：{{ addform.tscount }}</i></span> -->
            <el-checkbox style="margin-left: 15px;" v-model="checkexpire">包月</el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <el-button type="primary" @click="confirmAddSubscription('addsubscriptionrefs')">确定</el-button>
            <el-button @click="cancelAddSubscription">取消</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </div>

    <!-- 新增用户 -->
    <el-dialog
      :title="dialogtitle"
      custom-class="editdialog newadduserdialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="showadduserdialog"
      width="700px">
      <div class="edit-form">
        <el-form :model="adduserform" :rules="adduserformrules" ref="adduserformrefs" label-width="80px" size="small">
          <el-form-item label="用户名" prop="username">
            <el-col :span="12">
              <el-input v-model="adduserform.username"></el-input>
            </el-col>
            <el-col :span="12">
              <p>用户名5-25字符</p>
            </el-col>
          </el-form-item>
          <el-form-item label="代理商" prop="role" v-if="userlevel.isagency">
            <el-col :span="12">
              <el-checkbox v-model="userlevel.isagency" :disabled="true"></el-checkbox>
            </el-col>
            <el-col :span="12">
              <p>将该用户设为代理商身份</p>
            </el-col>
          </el-form-item>
          <!-- <el-form-item label="买手" prop="testbuyer" v-if="userlevel.istestbuyer">
            <el-col :span="12">
              <el-checkbox v-model="userlevel.istestbuyer" :disabled="userlevel.isadmin || userlevel.isagency">
                买手<span v-if="userlevel.isadmin">（该账户是管理员权限）</span>
              </el-checkbox>
            </el-col>
            <el-col :span="12">
              <p>将该用户设为买手身份</p>
            </el-col>
          </el-form-item> -->
          <el-form-item label="公司名称" prop="company">
            <el-col :span="12">
              <el-input v-model="adduserform.company"></el-input>
            </el-col>
            <el-col :span="12">
              <p>请输入公司名称</p>
            </el-col>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-col :span="12">
              <el-input v-model="adduserform.email"></el-input>
            </el-col>
            <el-col :span="12">
            </el-col>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-col :span="12">
              <el-input v-model="adduserform.phone" readonly onfocus="this.removeAttribute('readonly')"></el-input>
            </el-col>
            <el-col :span="12">
            </el-col>
          </el-form-item>
          <!-- <el-form-item label="定制报告" prop="url">
            <el-col :span="12">
              <el-input v-model="adduserform.url"></el-input>
            </el-col>
            <el-col :span="12">
              <p>请输入定制报告URL地址</p>
            </el-col>
          </el-form-item> -->
          <el-form-item label="密码" prop="password">
            <el-col :span="12">
              <el-input v-model="adduserform.password" show-password></el-input>
            </el-col>
            <el-col :span="12">
              <p>包含5-25个字符</p>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelUserDialog('adduserformrefs')" size="small">取 消</el-button>
        <el-button type="primary" :disabled="disableaddbtn" @click="confirmAddtUser('adduserformrefs')" size="small">确 定</el-button>
      </span>
    </el-dialog>
    
    <!--新增品牌-->
    <el-dialog
      title="新增品牌"
      custom-class="editdialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="showaddbranddialog"
      width="700px">
      <div class="edit-form">
        <el-form :model="addbrandform" :rules="addbrandrules" ref="addbrandformref" label-width="120px" size="small">
          <el-form-item label="品牌名称(中)" prop="name">
            <el-col :span="24">
              <el-input v-model="addbrandform.name"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="品牌名称(英)" prop="brand">
            <el-col :span="24">
              <el-input v-model="addbrandform.brand"></el-input>
            </el-col>
          </el-form-item>
          <!-- <el-form-item label="关键词" prop="keywords">
            <el-col :span="24">
              <el-input type="textarea" :rows="2" v-model="addbrandform.keywords" placeholder="多个关键词用逗号(,)隔开"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="品牌序列号">
            <el-col :span="24">
              <el-input v-model="addbrandform.trademark"></el-input>
            </el-col>
          </el-form-item> -->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelBrandDialog('addbrandformref')" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmAddBrand('addbrandformref')" size="small" :disabled="disableaddbtn">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import PageHeader from '@/components/NewSubscription/PageHeader'
import FormButton from '@/components/NewSubscription/FormButton'
import FormTooltip from '@/components/NewSubscription/FormTooltip'
export default {
  components: {
    PageHeader,
    FormButton,
    FormTooltip
  },
  data(){
    let isUrl = (rule, value, callback) => {
      let matchUrl = /^(https?:\/\/(([a-zA-Z0-9]+-?)+[a-zA-Z0-9]+\.)+[a-zA-Z]+)(:\d+)?(\/.*)?(\?.*)?(#.*)?$/
      if(value.trim().length<1){
        callback()
      }else{
        if (value.trim().length > 1000) {
          callback(new Error('不能超过1000个字符'))
          return
        } else {
          if (!matchUrl.test(value.trim())) {
            callback(new Error('不是正确网址'))
            return
          }else{
            callback()
          }
        }
      }
    }
    return{
      pickerOptions: {
        disabledDate: (time)=>{
          let that = this
          return that.dealDisabledDate(time)
        }
      },
      brandids: [],
      simplyusers: [], // 主/副负责人账号
      brandusers: [],  // 客户账号
      agencyusers: [], // 代理账号
      packageids: [],
      channels: [],
      showsaletype: false,
      monitortype: [{
        value: 1, name: '8次/天'
      },{
        value: 2, name: '3次/天'
      },{
        value: 5, name: '2次/天'
      },{
        value: 3, name: '1次/天'
      },{
        value: 4, name: '1次/周'
      },{
        value: '', name: '停止监测'
      }],
      showcustomtimes: false,
      monitortime: ['03', '06', '09', '12', '15', '18', '21', '24'],
      monitortime_min: 0,
      monitortime_max: 8,
      checked: '',
      checkexpire: false,
      duration: 0,
      addform: {
        brandid: '',
        mainid: '',
        name: '',
        init: '',
        expire: '',
        packageid: '',
        channel: '',
        category: '',
        userid: '',
        channelname: '',
        dmainid: '',
        tscount: '',
        saletype: '',
        duserid: '',
        url: '',
        monitortype: 1,
        monitortime: [],
        isDefault: false,
        CSM: '',
        DepCSM: ''
      },
      showadduserdialog: false,
      showaddbranddialog: false,
      adduserform: {
        username: '',
        company: '',
        email: '',
        phone: '',
        url: '',
        password: '',
        role: '',
        imgurl: ''
      },
      adduserformrules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 2, max: 25, message: '长度在 2 到 25 个字符', trigger: 'blur' }
        ],
        company: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
        ],
        url: [{ validator: isUrl, trigger: ['blur', 'change'] }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 5, max: 25, message: '长度在 5 到 25 个字符', trigger: 'blur' }
        ],
      },
      userlevel: {
        isadmin: false,
        isagency: false,
        istestbuyer: false
      },
      disableaddbtn: false,
      newuseremail: '',
      dialogtitle: '',
      addbrandrules: {
        name: { required: true, message: '不能为空', trigger: 'blur' },
        brand: { required: true, message: '不能为空', trigger: 'blur' },
      },
      addbrandform: {
        name: '',
        brand: '',
        logo: '',
        keywords: '',
        trademark: ''
      },
      newbrand: '',
      addsubscriptionrules: {
        brandid: { required: true, message: '不能为空', trigger: 'blur' },
        mainid: { required: true, message: '不能为空', trigger: 'blur' },
        name: { required: true, message: '不能为空', trigger: 'blur' },
        init: { required: true, message: '不能为空', trigger: 'blur' },
        expire: { required: true, message: '不能为空', trigger: 'blur' },
        packageid: { required: true, message: '不能为空', trigger: 'blur' },
        channel: { required: true, message: '不能为空', trigger: 'blur' },
        category: { required: true, message: '不能为空', trigger: 'blur' },
      },  
    }
  },
  mounted(){
    this.onChangeMonitortype(3)
    this.getBrand()
    this.getUser()
    this.getAgency()
    this.getPackage()
    this.getChannel()
  },
  methods: {
    
    /**
     * 限制到期时间晚于开始时间
     */
    dealDisabledDate: function(time){
      let that = this
      return time.getTime() <= new Date(that.addform.init).getTime()
    },

    addBrandDialog: function(){
      this.showaddbranddialog = true
    },
    
    addUserDialog: function(){
      this.dialogtitle = '新增用户'
      this.newuseremail = ''
      this.userlevel.isagency = false
      this.showadduserdialog = true
    },

    addAgencyDialog: function(){
      this.dialogtitle = '新增代理'
      this.newuseremail = ''
      this.userlevel.isagency = true
      this.showadduserdialog = true
    },

    cancelUserDialog: function(refs){
      this.$refs[refs].resetFields()
      this.showadduserdialog = false
    },

    cancelBrandDialog: function(refs){
      this.$refs[refs].resetFields()
      this.showaddbranddialog = false
    },

    cancelAddSubscription: function(){
      this.$router.push({name: 'Subscription'})
    },

    confirmAddSubscription: function(refs){
      let that = this
      console.log(that.addform)
      that.$refs[refs].validate(function(valid){
        if(valid){
          let url = that.API_URL + '/sys/subscription/add'
          if(that.addform.monitortype == 2 && that.addform.monitortime.length < 2){
            that.$message.error('必须选择监测时间')
            return
          }
          if(that.addform.monitortype == 3 && that.addform.monitortime.length < 1){
            that.$message.error('必须选择监测时间')
            return
          }
          let query = {
            brandid: that.addform.brandid,
            mainid: that.addform.mainid,
            name: that.addform.name,
            init: that.$moment(that.addform.init).format('YYYY-MM-DD 00:00:00'),
            expire: that.$moment(that.addform.expire).format('YYYY-MM-DD 23:59:59'),
            packageid: that.addform.packageid,
            channel: that.addform.channel.join(','),
            category: that.addform.category,
            userid: that.addform.userid,
            channelname: '',
            dmainid: that.addform.dmainid,
            tscount: that.checkexpire == true ? 9999999 : that.addform.tscount,
            saletype: that.addform.saletype,
            duserid: that.addform.duserid,
            url: that.addform.url,
            monitortype: that.addform.monitortype,
            monitortime: that.addform.monitortime.join(','),
            isDefault: that.isDefault,
            CSM: that.addform.CSM,
            DepCSM: that.addform.DepCSM
          }
          $.ajax({
            url: url,
            type: "POST",
            headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
            changeOrigin: true,
            crossDomain: true,
            data: query,
            success: function(data) {
              console.log('confirmAdd', data)
              that.$router.push({name: 'NewSKU',params: {taskid: data.result.taskId}})
            },
            error: function(response) {
              console.log('confirmAdd', response)
            }
          })
        }else{
          return false
        }
      })
    },

    /**
     * 获取品牌列表
     */
    getBrand: function(brand){
      let that = this
      let url = that.API_URL + '/sys/brand/list'
      $.ajax({
        url: url, type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true, crossDomain: true,
        data: {search: brand},
        success: function(data) {
          let origin_brand = JSON.parse(JSON.stringify(data.results))
          that.brandids = data.results
          if(that.newbrand != ''){
            let newbrandinfo = origin_brand.filter(item => item.name === that.newbrand)
            that.addform.brandid = newbrandinfo[0].brandId
          }
        },
        error: function(response) {
          console.log('getBrand', response)
        }
      })
    },

    /**
     * 获取用户列表
     */
    getUser: function(email){
      let that = this
      let url = that.API_URL + '/sys/users/list'
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {search: email},
        success: function(data) {
          let origin_user = JSON.parse(JSON.stringify(data.results))
          let _simplyusers = origin_user.filter(item => item.email.includes('simplybrand.com'))
          let _u = data.results.filter(item => {
            return item.roleid/1 != 2 && item.roleid/1 != 3
          })
          that.brandusers = _u
          that.simplyusers = _simplyusers
          if(that.newuseremail != ''){
            let newuserinfo = origin_user.filter(item => item.email === that.newuseremail)
            that.addform.userid = newuserinfo[0].userId
            that.addform.mainid = newuserinfo[0].mainId
          }
        },
        error: function(response) {
          console.log('getUser', response)
        }
      })
    },

    /**
     * 获取代理
     */
    getAgency: function(){
      let that = this
      let url = that.API_URL + '/sys/users/dlist'
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(data) {
          let _d = [{
            email: '无',
            mainId: 0,
            userId: 0
          }]
          _d = _d.concat(data.results)
          that.agencyusers = _d
          if(that.newuseremail != ''){
            let newuserinfo = _d.filter(item => item.email === that.newuseremail)
            that.addform.duserid = newuserinfo[0].userId
          }
        },
        error: function(response) {
          console.log('getAgency', response)
        }
      })
    },

    /**
     * 获取套餐
     */
    getPackage: function(pack){
      let that = this
      let url = that.API_URL + '/sys/package/list'
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {search: pack},
        success: function(data) {
          that.packageids = data.results
        },
        error: function(response) {
          console.log('getPackage', response)
        }
      })
    },

    /**
     * 获取渠道
     */
    getChannel: function(channel){
      let that = this
      let url = that.API_URL + '/sys/channel/list'
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {search: channel},
        success: function(data) {
          that.channels = data.results
        },
        error: function(response) {
          console.log('getChannel', response)
        }
      })
    },

    /**
     * 获取品牌名称
     */
     getBrandName: function(barandid){
      let that = this
      let userobj = {}
      userobj = that.brandids.find(function(item){
        return item.brandId === barandid
      })
      that.subscriptioninfo.brandname = userobj.name
    },

    /**
     * 获取用户mainid
     */
     getUserMainid: function(uid){
      let that = this
      let userobj = {}
      userobj = that.brandusers.find(function(item){
        return item.userId === uid
      })
      that.addform.mainid = userobj.mainId
    },

    /**
     * 获取代理mainid
     */
    getAgencyMainid: function(uid){
      let that = this
      let userobj = {}
      userobj = that.agencyusers.find(function(item){
        return item.userId === uid
      })
      that.addform.dmainid = userobj.mainId
      that.addform.duserid = userobj.userId
    },

    /**
     * 获取主负责人mainid
     */
    getCSMMainid: function(uid){
      let that = this
      let userobj = {}
      userobj = that.simplyusers.find(function(item){
        return item.userId === uid
      })
      that.addform.CSM = userobj.userId
    },
    
    /**
     * 获取副负责人mainid
     */
     getDepCSMMainid: function(uid){
      let that = this
      let userobj = {}
      userobj = that.simplyusers.find(function(item){
        return item.userId === uid
      })
      that.addform.DepCSM = userobj.userId
    },

    /**
     * 获取渠道名
     */
    getChannelName: function(cid){
      this.showsaletype = false
      for(let i=0; i<cid.length; i++){
        if(cid[i] * 1 === 1 || cid[i] * 1 === 2){
          this.showsaletype = true
        }
      }
    },

    /**
     * 选择套餐获取duration
     */
    selectPackage: function(pid){
      let that = this
      let packageobj = {}
      packageobj = that.packageids.find(function(item){
        return item.id === pid
      })
      that.duration = packageobj.duration
      if(that.addform.init !== ''){
        let _expire = that.$moment(that.addform.init).add(that.duration, 'months')
        that.addform.expire = that.$moment(_expire).subtract(1, 'days')
      }
    },

    /**
     * 自动获取套餐到期日
     */
    getExpireDate: function(){
      let that = this
      let _expire = that.$moment(that.addform.init).add(that.duration, 'months')
      that.addform.expire = that.$moment(_expire).subtract(1, 'days')
    },    

    onChangeMonitortime: function(val){
      let type = this.addform.monitortype
      if(val){
        if(type == 2){
          this.addform.monitortime = []
          this.monitortime_min = 0,
          this.monitortime_max = 3
        }
        if(type == 5){
          this.addform.monitortime = []
          this.monitortime_min = 0,
          this.monitortime_max = 2
        }
        if(type == 3){
          this.addform.monitortime = []
          this.monitortime_min = 0,
          this.monitortime_max = 1
        }
      } else{
        if(type == 2){
          this.addform.monitortime = ['03', '12', '18']
          this.monitortime_min = 3,
          this.monitortime_max = 3
        }
        if(type == 5){
          this.addform.monitortime = ['06', '18']
          this.monitortime_min = 2,
          this.monitortime_max = 2
        }
        if(type == 3){
          this.addform.monitortime = ['03']
          this.monitortime_min = 1,
          this.monitortime_max = 1          
        }
      }
    },

    onChangeMonitortype: function(val){
      /**
       * 是否显示“自定义时间”
       * 1、2、3显示。其余不显示
       */
      if(val == 1){
        this.showcustomtimes = false
        this.addform.isDefault = false
        this.addform.monitortype = 1
        this.addform.monitortime = ['03', '06', '09', '12', '15', '18', '21', '24']
        this.monitortime_min = 8,
        this.monitortime_max = 8
      }
      if(val == 2){
        this.showcustomtimes = true
        this.addform.isDefault = false
        this.addform.monitortype = 2
        this.addform.monitortime = ['03', '12', '18']
        this.monitortime_min = 3,
        this.monitortime_max = 3
      }
      if(val == 5){
        this.showcustomtimes = true
        this.addform.isDefault = false
        this.addform.monitortype = 5
        this.addform.monitortime = ['06', '18']
        this.monitortime_min = 2,
        this.monitortime_max = 2
      }
      if(val == 3){
        this.showcustomtimes = true
        this.addform.isDefault = false
        this.addform.monitortype = 3
        this.addform.monitortime = ['03']
        this.monitortime_min = 1,
        this.monitortime_max = 1
      }
      if(val == 4){
        this.showcustomtimes = false
        this.addform.isDefault = false
        this.addform.monitortype = 4
        this.addform.monitortime = ['03']
        this.monitortime_min = 1,
        this.monitortime_max = 1
      }
      if(val == ''){
        this.showcustomtimes = false
        this.addform.isDefault = false
        this.addform.monitortype = ''
        this.addform.monitortime = []
        this.monitortime_min = 0,
        this.monitortime_max = 0
      }
    },

    /**
     * 添加用户
     * role => 0: 管理员; 1: 普通用户; 2: 代理商; 3: 买手
     */
    confirmAddtUser: function(refs){
      let that = this
      that.$refs[refs].validate(function(valid){
        if (valid) {
          that.adduserform.role = that.userlevel.isagency ? 2 : that.userlevel.istestbuyer ? 3: 1
          that.newuseremail = that.adduserform.email
          that.checkEmail(that.adduserform.email, function(rs){
            if(rs){
              let url = that.API_URL + '/sys/users/add'
              let query = that.adduserform
              $.ajax({
                url: url,
                type: "POST",
                headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
                changeOrigin: true,
                crossDomain: true,
                data: query,
                success: function(data) {
                  console.log('confirmAddtUser', data)
                  that.showadduserdialog = false
                  that.$refs[refs].resetFields()
                  that.getUser()
                  if(that.userlevel.isagency){
                    that.getAgency()
                  }
                },
                error: function(response) {
                  console.log('confirmAddtUser', response)
                }
              })
            }else{
              that.$message({
                offset: 80,
                message: "邮箱已经存在",
                type: 'error'
              })
              that.disableaddbtn = false
            }
          })
        } else{
          return false
        }
      })
    },

    /**
     * 查找邮箱
     */
    checkEmail: function(email, callback){
      let that = this
      let url = that.API_URL + '/sys/users/check'
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {email: email, type: 0},
        success: function(data) {
          let availableemail = data.results.length === 0 ? true : false
          callback(availableemail)
        },
        error: function(response) {
          console.log('checkEmail', response)
        }
      })
    },
    
    /**
     * 确认新增品牌
     */
    confirmAddBrand: function(refs){
      let that = this
      that.$refs[refs].validate(function(valid){
        if(valid){
          that.disableaddbtn = true
          that.newbrand = that.addbrandform.name
          that.checkBrand(that.addbrandform.name, function(rs){
            if(rs){
              let url = that.API_URL + '/sys/brand/add'
              let query = that.addbrandform
              $.ajax({
                url: url,
                type: "POST",
                headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
                changeOrigin: true,
                crossDomain: true,
                data: query,
                success: function(data) {
                  console.log('confirmAddBrand', data)
                  that.showaddbranddialog = false
                  that.disableaddbtn = false
                  that.$refs[refs].resetFields(refs)
                  that.getBrand()
                },
                error: function(response) {
                  console.log('confirmAddBrand', response)
                }
              })
            }else{        
              that.$message({
                offset: 80,
                message: "品牌已经存在",
                type: 'error'
              })
              that.disableaddbtn = false
            }
          })
        }else{
          return false
        }
      })
    },

    checkBrand: function(brand, callback){
      let newbrandinfo = this.brandids.filter(item => item.name == brand)
      callback(newbrandinfo.length == 0)
    },

  }
}

</script>